(function($) {
    var authorContainer = $('#authors-container');
    var authors = authorContainer.children('.author-card');
  
    /**
     * Sort Author Cards
     * @param  {[type]} sortBy [description]
     * @return {[type]}        [description]
     */
    function sortAuthors(sortBy) {
  
      var sortReverse = false;
      var sortField = 'data-last-name';
  
      if(sortBy == 'first-name' || sortBy == 'first-name-reverse' ) {
        sortField = 'data-first-name';
      }
  
      if(sortBy == 'last-name-reverse' || sortBy == 'first-name-reverse' ) {
        sortReverse = true;
      }
  
      authors.sort(function(a,b){
        var an = a.getAttribute(sortField);
        var bn = b.getAttribute(sortField);
  
        if(an > bn) {
          return sortReverse ? -1 : 1;
        }
        if(an < bn) {
          return sortReverse ? 1 : -1;
        }
  
        return 0;
      });
  
      authors.detach().appendTo(authorContainer);
    }
  
    /**
    * Filter Author Cards
    * @param  {[type]} filterBy [description]
    * @return {[type]}          [description]
    */
    function filterAuthors(filterBy = false) {
  
      // console.log(authors.filter(':not([data-val' + filterBy + '])'));
  
      if(filterBy && filterBy != 'all' && filterBy != 'other') {
        // authors.filter(':not([' + filterBy + '])').addClass('hide');
        authors.each(function() {
          if($.inArray(filterBy, $(this).data('titles')) == -1) {
            $(this).addClass('hide');
          } else {
            $(this).removeClass('hide');
          }
        });
      } else {
        authors.removeClass('hide');
      }
  
    }
  
  
    $('#author-test-button').on('click', function() {
      filterAuthors();
    });
  
    $('#author-sort-name').on('change', function() {
      sortAuthors($(this).val());
    });
  
    $('#author-filter').on('change', function() {
      filterAuthors($(this).val());
    });
  
    $(document).ready(function(){
      if($('#author-sort-name').length) {
        var sortCriteria = $('#author-sort-name').val();
        sortAuthors(sortCriteria);
      }else {
        sortAuthors();
      }
    });
    
  })(jQuery);
  